import React, { createContext, useContext, useState, useEffect } from 'react';
import "core-js/stable/atob";

// JWT декодування (npm install jwt-decode)
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true); // додаємо стан для завантаження


    const login = async (email, password) => {
        const { data } = await axios.post('https://hub2.daolog.net/login', { email, password });
        localStorage.setItem('authToken', data.accessToken);
        localStorage.setItem('refreshToken', data.refreshToken);
        setUser(jwtDecode(data.accessToken));
    };

    const logout = async () => {
        const refreshToken = localStorage.getItem('refreshToken');
        await axios.post('https://hub2.daolog.net/auth/logout', { refreshToken });
        localStorage.removeItem('authToken');
        localStorage.removeItem('refreshToken');
        setUser(null);
    };

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        if ((token !== 'undefined') && token) {
            setUser(jwtDecode(token));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
        setLoading(false);

    }, []);
    if (loading) {
        return <div>Завантаження...</div>;
    }
    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
